export default __webpack_public_path__ + "static/healthcare-page-step-1-c27b017221246e423f520046772fb267.svg";